import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import frCAnumbers from 'cldr-numbers-full/main/fr-CA/numbers.json';
import frCAcaGregorian from 'cldr-dates-full/main/fr-CA/ca-gregorian.json';
import frCAdateFields from 'cldr-dates-full/main/fr-CA/dateFields.json';
import frCAtimeZoneNames from 'cldr-dates-full/main/fr-CA/timeZoneNames.json';
import frCACurrencyData from 'cldr-numbers-full/main/fr-CA/currencies.json';
import { loadMessages, LocalizationProvider, IntlProvider, load } from "@progress/kendo-react-intl";

export default function GridWrapper(props: any) {

    loadMessages(require("./../../configs/kendoMessages.json"), "fr-CA");
    load(
        likelySubtags,
        currencyData,
        weekData, frCAnumbers,
        frCAcaGregorian,
        frCAdateFields,
        frCAtimeZoneNames,
        frCACurrencyData
    );
    return <LocalizationProvider language="fr-CA">
        <IntlProvider locale="fr-CA">
            {props.children}
        </IntlProvider>
    </LocalizationProvider>
}